import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AppleIcon from "@mui/icons-material/Apple";
import { getFullApiUrl } from "../config";
import { Icon } from "../designSystem";

const AppsPage = () => {
  const [latestVersion, setLatestVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatestVersion = async () => {
      try {
        const response = await fetch(
          getFullApiUrl("/api/v1/app/latest-version?platform=android")
        );

        if (response.ok) {
          const data = await response.json();
          setLatestVersion(data);
        } else {
          console.warn("Failed to fetch latest version, status:", response.status);
        }
      } catch (err) {
        console.error("Error fetching latest version:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestVersion();
  }, []);

  const handleAndroidDownload = () => {
    window.location.href = "https://cdn.leftovertalk.com/apk/fansapp-latest";
  };

  const handleIOSDownload = () => {
    window.open(
      "https://apps.apple.com/app/%E8%BE%B9%E8%A7%92%E8%81%8A/id6752470699",
      "_blank"
    );
  };

  return (
    <div className="lt-main" style={{ maxWidth: 760 }}>
      <div className="lt-pagehead" style={{ textAlign: "center" }}>
        <h1>下载客户端</h1>
        <p>在移动设备上获得更好的收听体验。</p>
      </div>

      <div className="lt-appcards">
        <div
          className="lt-appcard"
          role="button"
          tabIndex={0}
          onClick={handleAndroidDownload}
          onKeyDown={(e) => e.key === "Enter" && handleAndroidDownload()}
        >
          <span className="lt-appcard__glyph">
            <Icon name="android" style={{ verticalAlign: 0, color: "#3DDC84" }} />
          </span>
          <h2>Android</h2>
          <span className="d">适用于 Android 设备 · 直接下载 APK</span>
          {loading ? (
            <span className="lt-loading-dot" style={{ width: 18, height: 18 }} />
          ) : latestVersion ? (
            <span className="v">最新版本 {latestVersion.version_name}</span>
          ) : null}
          <span
            style={{
              color: "var(--accent-strong)",
              fontWeight: 600,
              fontSize: "var(--text-sm)",
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Icon name="download" size={18} />
            下载安装包
          </span>
        </div>

        <div
          className="lt-appcard"
          role="button"
          tabIndex={0}
          onClick={handleIOSDownload}
          onKeyDown={(e) => e.key === "Enter" && handleIOSDownload()}
        >
          <span className="lt-appcard__glyph">
            <AppleIcon sx={{ fontSize: 44 }} />
          </span>
          <h2>iOS</h2>
          <span className="d">适用于 iPhone · App Store 免费下载</span>
          <span
            style={{
              color: "var(--accent-strong)",
              fontWeight: 600,
              fontSize: "var(--text-sm)",
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Icon name="north_east" size={18} />
            前往 App Store
          </span>
        </div>
      </div>

      <p
        style={{
          textAlign: "center",
          marginTop: 28,
          fontSize: "var(--text-sm)",
          color: "var(--text-3)",
        }}
      >
        需要帮助？看看<Link to="/help">帮助中心</Link>。
      </p>
    </div>
  );
};

export default AppsPage;
